(() => {
  class AndCharlieVideoHero {
    constructor(video) {
      this.video = video;
      this.autoplay = video.autoplay;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.syncMotion = this.syncMotion.bind(this);
      this.reduceMotion.addEventListener('change', this.syncMotion);
      this.syncMotion();
    }

    syncMotion() {
      // Disable native autoplay too, including while the video is still loading.
      this.video.autoplay = this.autoplay && !this.reduceMotion.matches;
      if (this.reduceMotion.matches) {
        this.video.pause();
      } else if (this.autoplay) {
        this.video.play().catch(() => {});
      }
    }

    destroy() {
      this.reduceMotion.removeEventListener('change', this.syncMotion);
      this.video.autoplay = this.autoplay;
    }
  }

  function initAndCharlieVideoHeroes(scope = document) {
    scope.querySelectorAll('[data-ac-video-hero]').forEach((root) => {
      if (root.andCharlieVideoHero) return;
      const video = root.querySelector('video');
      if (video) root.andCharlieVideoHero = new AndCharlieVideoHero(video);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAndCharlieVideoHeroes();
    });
  } else {
    initAndCharlieVideoHeroes();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAndCharlieVideoHeroes(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ac-video-hero]').forEach((root) => {
      root.andCharlieVideoHero?.destroy();
      delete root.andCharlieVideoHero;
    });
  });
})();
